// extracted by mini-css-extract-plugin
export default {"whatHappened":"WhatHappened_whatHappened__MMW2E"};